import { message } from 'antd';
import {
  getDetail,
  getParticipant,
  pushMeeting,
  delMeeting,
  sendReason,
  confirmAttend,
  cancelLeave,
} from '../../../../services/meetingManage/meetingDetail';

const initState = {
  detail: {},
  // 加载信息,
  participantList: [],
  spinProps: {
    spinning: true,
    tip: '加载中...',
  },
  // expand: false,
};

export default {
  namespace: 'meetingDetail',

  state: initState,

  effects: {
    // 获取会议详情
    *fetchDetail({ params, callback }, { call, put }) {
      try {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中',
            },
          },
        });
        const response = yield call(getDetail, params);

        yield put({
          type: 'save',
          payload: {
            detail: response,
            spinProps: {
              spinning: false,
            },
          },
        });
        if (callback) {
          callback();
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },

    // 获取参会人列表
    *fetchParticipantList({ params, callback }, { call, put }) {
      try {
        const response = yield call(getParticipant, params);

        yield put({
          type: 'save',
          payload: {
            participantList: response,
          },
        });
        if (callback) {
          callback();
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },

    // 发布会议
    *fetchPushMeeting({ params, callback }, { call, put }) {
      try {
        yield call(pushMeeting, params);
        message.success('发布成功');
        if (callback) {
          callback();
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },

    // 删除会议
    *fetchDelMeeting({ params, callback }, { call, put }) {
      try {
        yield call(delMeeting, params);
        message.success('删除成功');
        if (callback) {
          callback();
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },

    // 发送请假理由
    *fetchSendReason({ params, callback }, { call, put }) {
      try {
        yield call(sendReason, params);
        message.success('请假成功');
        if (callback) {
          callback();
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },

    // 确认参加
    *fetchConfirmAttend({ params, callback }, { call, put }) {
      try {
        yield call(confirmAttend, params);
        message.success('确认参加成功');
        if (callback) {
          callback();
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },

    // 取消请假
    *fetchCancelLeave({ params, callback }, { call, put }) {
      try {
        yield call(cancelLeave, params);
        message.success('取消请假成功');
        if (callback) {
          callback();
        }
      } catch (error) {
        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState };
    },
  },
};
